function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField, Typography } from 'seagull';
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./StopPaymentModal.module.scss";
import { requiredValidation } from 'validators';
export default function StopPaymentModal(props) {
  const {
    formattedNumber,
    onSubmit,
    dismissModal
  } = props;
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      reason: ''
    }
  });
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Stop Payment?",
    textAlignCenter: false,
    primaryButtonLabel: "Stop",
    primaryButtonTestid: "submit-stop-payment",
    secondaryButtonLabel: "Back",
    onSecondaryButtonClick: () => dismissModal(),
    onPrimaryButtonClick: handleSubmit(async _ref => {
      let {
        reason
      } = _ref;
      const {
        success
      } = await onSubmit(reason.trim());
      if (success) dismissModal();
    }),
    content: /*#__PURE__*/React.createElement("div", {
      className: styles.root
    }, /*#__PURE__*/React.createElement(Typography, null, "You're about to stop a payment for invoice ", formattedNumber, "."), /*#__PURE__*/React.createElement(Typography, null, "Please provide a reason for stopping:"), /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "reason",
      rules: requiredValidation(true),
      render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({
        multiline: true,
        minRows: 6,
        testid: "stop-payment-reason",
        placeholder: "[Example text] Can you remind me what this payment is for? Please call me to discuss..."
      }, connectControllerToTextField(renderProps)))
    }))
  });
}